// Who did it, as shown in a history / activity line: "Me" for the signed-in user's own entries,
// their name for everyone else. Matched on the user id the backend stamps on the entry
// (e.g. invoice history `by_user_id`) — never on the display name, which two users can share.
// Entries without an id (older records, system actors like "QuickBooks") keep their name.
import type { TFunction } from 'i18next';

export const isOwnEntry = (actorUserId: string | null | undefined, currentUserId: string | null | undefined): boolean =>
  !!actorUserId && !!currentUserId && actorUserId === currentUserId;

export const actorLabel = (
  name: string,
  actorUserId: string | null | undefined,
  currentUserId: string | null | undefined,
  t: TFunction,
): string => (isOwnEntry(actorUserId, currentUserId) ? t('common.me', 'Me') : name);
